/**
 * @fileoverview Estado do item "Ordens de serviço" dos menus (computador e
 * celular): aparece para quem vê as OS (layout/navigation.js) quando a empresa
 * tem fonte de OS ou já recebeu OS, e pede atenção ("!") quando algum coletor
 * está sem sinal, pedindo login ou com erro. Relê a cada 5 min (o "sem sinal"
 * aparece sem evento) e na hora em que um coletor manda sinal.
 */

import { useContext, useEffect, useState } from "react";
import api from "../../services/api";
import { SocketContext } from "../../context/Socket/SocketContext";
import useNavigation from "../../layout/navigation";
import usePermission from "../usePermission";

const REFRESH_MS = 5 * 60 * 1000;
const HIDDEN = { visible: false, attention: false };

const useWorkOrdersMenu = (user) => {
  const socketManager = useContext(SocketContext);
  const [state, setState] = useState(HIDDEN);
  const companyId = user?.companyId;
  // Espera o acesso da pessoa chegar, para não pedir as fontes com a regra de hoje.
  const { loaded } = usePermission();
  const canSee = useNavigation(user)("workOrders") && loaded;

  useEffect(() => {
    if (!companyId || !canSee) {
      setState(HIDDEN);
      return undefined;
    }
    let active = true;
    const fetchSources = async () => {
      try {
        const { data } = await api.get("/work-orders/sources");
        if (!active) return;
        setState({
          visible: (data.sources || []).length > 0 || !!data.hasWorkOrders,
          attention: !!data.needsAttention,
        });
      } catch (err) {
        // Sem acesso ou falha momentânea: mantém o que já estava.
      }
    };
    fetchSources();
    const timer = setInterval(fetchSources, REFRESH_MS);
    const socket = socketManager.getSocket(companyId);
    socket.on(`company-${companyId}-workOrderSource`, fetchSources);
    return () => {
      active = false;
      clearInterval(timer);
      // disconnect() do socket gerenciado só solta os ouvintes deste uso (off()
      // deixava para trás o ouvinte de "connect" de cada getSocket).
      socket.disconnect();
    };
  }, [socketManager, companyId, canSee]);

  return state;
};

export default useWorkOrdersMenu;
